// Get Requests that only fetch data

import { useQuery } from "react-query";
import { getCountryPhoneCode, getCountrySubdivision } from "./gateway";

export function useCountryNumericCodeData(countryNumericCode: string) {
  return useQuery({
    queryFn: () => getCountrySubdivision(countryNumericCode),
    queryKey: ["countryNumericCode", countryNumericCode],
  });
}

export function usePhoneCodeData(countryNumericCode: string) {
  return useQuery({
    queryFn: () => getCountryPhoneCode(countryNumericCode),
    queryKey: ["phoneCode", countryNumericCode],
  });
}
